<div class="container-fluid">
    <div class="row">
      <div *ngIf="caseDetails && caseDetails.settings.allowAddAdditions" class="col-12" style="display:flex;justify-content: flex-start;" >
        <button class="btn btn-primary m-3" (click)="openCreateModal()">
            <i class="fa fa-plus-circle"></i>
            <span> {{'AddAdditionRequest' | translate}} </span>
        </button>
      </div>
      <div class="col-sm-12">
        <div *ngIf="!showAddPage && !showEditPage" class="card">
          <table class="table table-striped mt-3">
            <thead class="thead-dark">
              <tr>
                <th>{{ "Title" | translate }}</th>
                <th>{{ "prosecutionName" | translate }}</th>
                <th>{{ "Description" | translate }}</th>
                <th>{{ "RequestStatus" | translate }}</th>
                <th>{{ "FirstSentToProsecution" | translate }}</th>
                <th>{{ "ProsecutionRefId" | translate }}</th>
                <th scope="col">{{"Preview" | translate}}</th>
                <th scope="col" >{{ "Edit" | translate }}</th>
                <th scope="col">{{ "Delete" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let additionRequest of additionRequestArr">
                <td>{{ additionRequest.title }}</td>
                <td>{{ additionRequest.prosecutionName }}</td>
                <td>{{ additionRequest.description }}</td>
                <td>{{additionRequest.additionStatusName ? additionRequest.additionStatusName : '-'}}</td>
                <td>{{ additionRequest.isSentToProsecution ?  (additionRequest.prosecutionSentDate | toDateOnly )  : '-'}}</td>
                <td>{{ additionRequest.isSentToProsecution ? additionRequest.prosecutionRefId : '-'  }}</td>
                <td>
                    <a (click)="additionRequestPreview(additionRequest,previewAdditionRequest)" href="javascript:void(0)">
                        <i class="fa fa-eye"></i>
                    </a>
                </td>
                <td >
                  <a *ngIf="additionRequest.additionStatusId==1 && caseDetails && caseDetails.settings.allowAddAdditions ; else anotherA" style="cursor: pointer;" (click)="editAdditionRequest(additionRequest)" >
                    <i class="fa fa-edit"></i>
                  </a>
                  <ng-template #anotherA>
                    <span>-</span>
                  </ng-template>
                </td>
                <td>
                  <a  *ngIf="caseDetails && caseDetails.settings.allowAddAdditions  ; else elseTemplate" (click)="deleteAdditionRequest(additionRequest.additionRequestId, deleteModal)" style="cursor: pointer;">
                    <i class="fa fa-trash"></i>
                  </a>
                  <ng-template #elseTemplate>
                    <span>-</span>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- add page -->
        <div *ngIf="showAddPage" class="card p-3">
          <h4 class="modal-title" id="modal-basic-title">
            {{ "AddAdditionRequest" | translate }}
          </h4>
          <div class="form-group row mt-3">
              <div class="col-lg-12">
                  <div style="display: flex; flex-wrap: nowrap; height: 30px">
                      <label>{{ "Title" | translate }}</label>
                      <span  *ngIf="Title.invalid" class="alert" style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                          <div *ngIf="Title.errors?.required">*</div>
                      </span>
                  </div>
                  <input type="text" id="Title" required #Title="ngModel" class="form-control" [(ngModel)]="title" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Title' | translate }}">
              </div>
             
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                    <label>{{ "prosecutionName" | translate }}</label>
                    <span  *ngIf="ProsecutionName.invalid" class="alert" style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                        <div *ngIf="ProsecutionName.errors?.required">*</div>
                    </span>
                </div>
                <ng-select type="text" id="ProsecutionName" required #ProsecutionName="ngModel" class="form-control-select" [items]="branchProsecutionArr" bindLabel="text" bindValue="id" [(ngModel)]="prosecuationId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'prosecutionName' | translate }}"></ng-select>
            </div>
           
          </div>
          <div class="form-group row mt-3">
              <div class="col-lg-12">
                  <div style="display: flex; flex-wrap: nowrap; height: 30px">
                      <label>{{ "Description" | translate }}</label>
                      <span  *ngIf="Description.invalid" class="alert" style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                          <div *ngIf="Description.errors?.required">*</div>
                      </span>
                  </div>
                  <textarea id="Description" required #Description="ngModel" class="form-control"
                  rows="2" [(ngModel)]="description" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Description' | translate }}"
                  > </textarea>
              </div>
          </div>
          
          <h4 class="mt-3" *ngIf="AttachShow" >{{ "Attachments" | translate }}</h4>
          <hr>
          <app-general-attachment *ngIf="AttachShow" (attachAdded)="hasAttachment=true" (LengthData)="ToLength($event)"  [ElementTypeId]="'15'" [loadDataFP]="loadfromparent2"></app-general-attachment>
          <hr *ngIf="lengthAttach==0">

          <h6 style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;" *ngIf="lengthAttach==0">{{'noSendToNoAtt'|translate}}</h6>
          <div class="row mt-3" style="justify-content: center">
            <button [disabled]="Title.invalid || Description.invalid || ProsecutionName.invalid" (click)="addAdditionRequest()" type="button" class="btn btn-primary col-lg-2 m-1" >
              {{ "Save" | translate }}
            </button>
            <button [disabled]="!AttachShow || !hasAttachment" type="button" class="btn btn-primary col-lg-3 m-1" (click)="sendAdditionRequest(true)">
              {{ "Send and Back" | translate }}
            </button>
            <button type="button" class="btn btn-danger col-lg-3 m-1" (click)="showAddPage =false; showEditPage=false;">
              {{ "BackLists" | translate }}
            </button>
          </div>
        </div>
        <!-- edit page -->
        <div *ngIf="showEditPage" class="card p-3">
          <h4 class="modal-title" id="modal-basic-title">
            {{ "EditAdditionRequest" | translate }}
          </h4>
          <div class="form-group row mt-3">
              <div class="col-lg-12">
                  <div style="display: flex; flex-wrap: nowrap; height: 30px">
                      <label>{{ "Title" | translate }}</label>
                      <span  *ngIf="TitleEdit.invalid" class="alert" style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                          <div *ngIf="TitleEdit.errors?.required">*</div>
                      </span>
                  </div>
                  <input type="text" id="TitleEdit" required #TitleEdit="ngModel" class="form-control" [(ngModel)]="editedAdditionRequest.title" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Title' | translate }}">
              </div>
             
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
                <div style="display: flex; flex-wrap: nowrap; height: 30px">
                    <label>{{ "prosecutionName" | translate }}</label>
                    <span  *ngIf="ProsecutionNameEdit.invalid" class="alert" style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                        <div *ngIf="ProsecutionNameEdit.errors?.required">*</div>
                    </span>
                </div>
                <ng-select type="text" id="ProsecutionNameEdit" required #ProsecutionNameEdit="ngModel" class="form-control-select" [items]="branchProsecutionArr" bindLabel="text" bindValue="id" [(ngModel)]="editedAdditionRequest.prosecutionId" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'prosecutionName' | translate }}"></ng-select>
            </div>
           
          </div>
          <div class="form-group row mt-3">
              <div class="col-lg-12">
                  <div style="display: flex; flex-wrap: nowrap; height: 30px">
                      <label>{{ "Description" | translate }}</label>
                      <span  *ngIf="DescriptionEdit.invalid" class="alert" style="color: red;white-space: nowrap;line-height: 0; padding: 0;margin-top: 8px;">
                          <div *ngIf="DescriptionEdit.errors?.required">*</div>
                      </span>
                  </div>
                  <textarea id="DescriptionEdit" required #DescriptionEdit="ngModel" class="form-control"
                  rows="2" [(ngModel)]="editedAdditionRequest.description" [ngModelOptions]="{ standalone: true }" placeholder="{{ 'Description' | translate }}"
                  > </textarea>
              </div>
          </div>
          <h4 class="mt-3">{{ "Attachments" | translate }}</h4>
          <hr>
          <app-general-attachment [ElementTypeId]="'15'" [loadDataFP]="loadfromparent3"></app-general-attachment>
          <div class="row mt-3" style="justify-content: center;">
            <button [disabled]="TitleEdit.invalid || DescriptionEdit.invalid || ProsecutionNameEdit.invalid" (click)="onEditAdditionRequest()" type="button" class="btn btn-primary col-lg-2 m-1" >
              {{ "Save" | translate }}
            </button>
            <button type="button" class="btn btn-primary col-lg-3 m-1" (click)="sendAdditionRequest(false)">
              {{ "Send and Back" | translate }}
            </button>
            <button type="button" class="btn btn-danger col-lg-3 m-1" (click)="showAddPage=false; showEditPage=false;">
              {{ "BackLists" | translate }}
            </button>
          </div>
          
        </div>
      </div>
    </div>
</div>

<ng-template #deleteModal let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "ConfirmDeleteOperation" | translate }}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body text-center">
        <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeleteAdditionRequest(modal)">
            {{ "YES" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "NO" | translate }}
        </button>
    </div>
</ng-template>
  
<ng-template #AddAttachment let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{'Attachments'|translate}}
        </h4>
        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>

    </div>
    <div class="modal-body text-center">
        <app-general-attachment   [ElementTypeId]="'15'" [loadDataFP]="loadfromparent"></app-general-attachment>
  
    </div>
    <div class="modal-footer">
       
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
</ng-template>
<ng-template #previewAdditionRequest let-modal>
    <div class="modal-header" style="justify-content: space-between">
      <h4 class="modal-title" id="modal-basic-title">
        {{ "PreviewAdditionRequest" | translate }}
      </h4>
  
      <i
        style="font-size: 20px"
        class="fa fa-close"
        (click)="modal.dismiss('Cross click')"
      ></i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
              <div class="card p-3">
                <div class="form-group row">
                    <div class="col-lg-12">
                        <label>{{ "Title" | translate }}</label>
                        <span class="form-control" readonly>{{editedAdditionRequest.title}}&nbsp;</span>
                    </div>
                </div>
                <div class="form-group row mt-3">
                  <div class="col-lg-12">
                    <label>{{ "prosecutionName" | translate }}</label>
                    <span class="form-control" readonly>{{ editedAdditionRequest.prosecutionName}}&nbsp;</span>
                  </div>
                </div>
                <div class="form-group row mt-3">
                    <div class="col-lg-12">
                        <label>{{ "Description" | translate }}</label>
                        <span class="form-control" readonly>{{editedAdditionRequest.description}}&nbsp;</span>
                    </div>
                </div>
                <div class="form-group row mt-3">
                  <div class="col-lg-12">
                    <label>{{ "RequestStatus" | translate }}</label>
                    <!-- additional request status base on additionStatusName -->
                    <span class="form-control" readonly>{{editedAdditionRequest.additionStatusName ? editedAdditionRequest.additionStatusName : '-'}}</span>

                    <!-- <span *ngIf="editedAdditionRequest.isAccepted==null" class="form-control" readonly>{{'AwaitingApproval' | translate }}&nbsp;</span>
                    <span class="form-control" readonly *ngIf="editedAdditionRequest.isAccepted==false">
                      {{ "RequestHasBeenRejected" | translate}} &nbsp;
                      <br>
                      {{'TheReason' | translate}} : {{editedAdditionRequest.rejectReason}} &nbsp;
                    </span>
                    <span class="form-control" readonly *ngIf="editedAdditionRequest.isAccepted==true && editedAdditionRequest.isSentToProsecution==true ">{{ "SentToTheProsecution" | translate}}&nbsp;</span>
                    <span class="form-control" readonly *ngIf="editedAdditionRequest.isAccepted==true && editedAdditionRequest.isSentToProsecution==false ">{{ "TheRequestHasBeenApproved" | translate}}&nbsp;</span>-->
                    
                  </div> 
                </div>
                <div class="form-group row mt-3">
                  <div class="col-lg-12">
                      <label>{{ "FirstSentToProsecution" | translate }}</label>
                      <span class="form-control" readonly>{{editedAdditionRequest.isSentToProsecution ? (editedAdditionRequest.prosecutionSentDate | toDateOnly ) : '-'}}&nbsp;</span>
                  </div>
                </div>
                <div class="form-group row mt-3">
                  <div class="col-lg-12">
                      <label>{{ "ProsecutionRefId" | translate }}</label>
                      <span class="form-control" readonly>{{editedAdditionRequest.isSentToProsecution ? editedAdditionRequest.prosecutionRefId : '-'}}&nbsp;</span>
                  </div>
                </div>
                <hr>
                <h3>{{'Attachments' | translate}}</h3>
                <app-general-attachment *ngIf="editedAdditionRequest==null || editedAdditionRequest.additionStatusId==1" [ElementTypeId]="'15'" [loadDataFP]="loadfromparent4"></app-general-attachment>
                <div *ngIf="editedAdditionRequest!=null && editedAdditionRequest.additionStatusId!=1" class="row">
                  <div>
                    <table class="table table-striped">
                        <thead class="bg-primary">
                            <tr>

                                <th>{{'fileName'|translate}}</th>
                                <th>{{'AttachmentType'|translate}}</th>
                                <th>{{'incommingOrgName'|translate}}</th>
                                <th>{{'descriptionAtt'|translate}}</th>
                                <th>{{'SendStatus'|translate}}</th>
                                <th>{{'Actions' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let att of attachmentList">

                                <td class="p-3">{{ att.attachment.fileName}}</td>
                                <td class="p-3">{{ att.attachment.attachmentTypeName}}</td>
                                <td class="p-3"> {{att.attachment.incommingOrgName ? att.attachment.incommingOrgName : '-' }}</td>
                                <td class="p-3">
                                    {{att.attachment.description ? att.attachment.description : '-'}}
                                    <br />
                                    <span *ngIf="att.attachment.creatorName!=null" style="font-size: 10px;">{{'companyandBy'|translate}}:{{att.creatorName}}</span>
                                    <br />
                                    <span *ngIf="att.attachment.createdOn!=null" style="font-size: 10px;">{{'createDate'|translate}}:{{ att.createdOn | toDateTime}}</span>
                                </td>

                                <td class="p-3">
                                    <i *ngIf="att.isSend==true" class="fa fa-check-circle text-success"></i>
                                    <i *ngIf="att.isSend==false" class="fa fa-times-circle text-danger"></i>
                                    <p *ngIf="att.isSend==false">{{att.response}}</p>
                                </td>

                                <td class="p-3">
                                    <a (click)="download(att.attachment);" class="btn btn-sm btn-outline-primary ms-1 pb-0">
                                        <app-feather-icons [icon]="'download'"></app-feather-icons>
                                    </a>
                                    <a *ngIf="att.attachment.fileType=='image/jpeg' || att.attachment.fileType=='image/jpg' || att.attachment.fileType=='image/png' || att.attachment.fileType=='application/pdf'"
                                       (click)="previewPDF(att.attachment,pdfViewer)" class="btn btn-sm btn-outline-dark ms-1 pb-0">
                                        <app-feather-icons [icon]="'eye'"></app-feather-icons>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row" style="justify-content: flex-end; padding: 1rem 2rem" >
        <button *ngIf="(Process.Company && sharedService.hasRole(RoleEnum.Manager)) || (Process.Consumer && sharedService.hasRole(RoleEnum.Quality))" (click)="open(RefusedRequestModal)" type="button" class="btn btn-primary col-lg-2" >
            {{ "Refused" | translate }}
        </button>
          
        <button *ngIf="(Process.Company && sharedService.hasRole(RoleEnum.Manager)) || (Process.Consumer && sharedService.hasRole(RoleEnum.Quality))" (click)="isAcceptFun(true)" type="button" class="btn btn-primary col-lg-3" >
            {{ "SentToProsecution" | translate }}
        </button>
        <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
      
    </div>
    
</ng-template>
<ng-template #RefusedRequestModal let-modal>
  <div class="modal-header" style="justify-content: center">
    <h4 class="modal-title" id="modal-basic-title">
      {{ "Confirm" | translate }}
    </h4>
  </div>
  <div class="modal-body text-center">
    <div class="row">
      <div class="col-lg-12">
        <div style="display: flex; flex-wrap: nowrap; height: 30px">
          <label>{{ "TheReason" | translate }}</label>
          <span *ngIf="TheReason.invalid" class="alert"
            style="color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
            <div *ngIf="TheReason.errors?.required">*</div>
          </span>
        </div>
        <textarea id="TheReason" required #TheReason="ngModel" class="form-control" rows="2"
          [(ngModel)]="editedAdditionRequest.rejectReason" [ngModelOptions]="{ standalone: true }"
          placeholder="{{ 'TheReason' | translate }}">
          </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="TheReason.invalid" (click)="isAcceptFun(false)">
      {{ "Confirm" | translate }}
    </button>
  </div>
</ng-template>
<ng-template #pdfViewer let-modal>
  <div class="modal-body text-center">
    <div style="position:absolute; top:40%; left:45%;  z-index:-1;">
        <div class="spinner-border text-success" role="status">
        </div>
        <br />
        <br />
        <span> {{'uploadFile'|translate}} ...</span>
    </div>
    <i (click)="modal.dismiss('Cross click')" style="position: absolute;z-index: 1;left: 45px;font-size: 25px;" class="fa fa-close"></i>
    <pdf-viewer *ngIf="pdfFile" [src]="doc" [render-text]="true" [original-size]="false" [show-all]="true" [show-borders]="true"></pdf-viewer>
    <img style="width:100%;" *ngIf="!pdfFile" [src]="image" alt="">
  </div>
</ng-template>